<template>
    <div
     style="width: 100%; height: 100%;"
     v-loading="isWeiXinBrowser"
     element-loading-spinner="1"
     element-loading-background="rgba(0, 0, 0, 1)">
        <Student ref="component" v-if="!isWeiXinBrowser && live_check"></Student>
        <DeviceCheck type="student" :stepsIndex="1" @changeLiveCheck="changeLiveCheck" v-else-if="!isWeiXinBrowser && !live_check"></DeviceCheck>
    </div>
</template>
<script>
import DeviceCheck from './components/deviceCheck.vue';
import Student from './student.vue';

export default {
    components: { DeviceCheck, Student },
    data() {
        return {
            live_check: false,
            isWeiXinBrowser: false,
        }
    },
    created() {
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.isWeiXinBrowser = true;
            this.$notify({
                title: '当前浏览器不支持',
                message: '请使用谷歌浏览器或者系统浏览器打开',
                showClose: false,
                duration: 0
            });
        } else if(localStorage.getItem('live_check'))
            this.live_check = true;
    },
    beforeRouteLeave (to, from, next) {
        this.$refs.component.quitClass(next);
    },
    methods: {
        changeLiveCheck() {
            this.live_check = true;
            localStorage.setItem('live_check', true)
        },
    },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/classroom1/index.vue